import { CommonModule } from '@angular/common';
import { Component, computed, EventEmitter, inject, input, Output, Signal } from '@angular/core';
import { Router } from '@angular/router';

import { DateTime } from 'luxon';

import { CurrencyCustomPipe } from '../../pipes';
import { GuardOwnShiftItem, SHIFT_STATUSES } from '../../types';
import { AvatarImageComponent } from '../avatar-image/avatar-image.component';
import { CardComponent } from '../card/card.component';
import { StatusChipComponent } from '../status-chip/status-chip.component';

@Component({
    selector: 'lib-shift-list-item',
    imports: [CommonModule, CardComponent, CurrencyCustomPipe, AvatarImageComponent, StatusChipComponent],
    templateUrl: './shift-list-item.component.html',
    styleUrl: './shift-list-item.component.css'
})
export class ShiftListItemComponent {
    /* eslint-disable */
    router = inject(Router);

    shift = input<GuardOwnShiftItem | null>(null);

    button = input<boolean>(false);
    topMargin = input<boolean>(false);
    bottomMargin = input<boolean>(true);

    displayRelativeDate = input<boolean>(true);
    displayDistance = input<boolean>(true);
    displayRate = input<boolean>(false);
    displayStatus = input<boolean>(false);

    navigateToShiftDetails = input<boolean>(false);

    @Output() onClick: EventEmitter<number> = new EventEmitter();

    dateToday: Signal<string> = computed(() => DateTime.now().toFormat('yyyy-MM-dd'));

    //Compares the shift's end_date and end_time to the current datetime
    isShiftCompleted: Signal<boolean> = computed(() => {
        const shift = this.shift();
        if (!shift) return false;
        const shiftEndDateTime = DateTime.fromISO(`${shift.end_date} ${shift.end_time}`);
        const currentDateTime = DateTime.now();

        return shiftEndDateTime > currentDateTime;
    });

    readonly SHIFT_STATUSES = SHIFT_STATUSES;

    click() {
        if (!this.button()) return;
        if (this.navigateToShiftDetails()) {
            this.router.navigateByUrl(`/shift/${this.shift()?.id}`);
            return;
        } else {
            this.onClick.emit(this.shift()?.id);
        }
    }
}
